// Google Cast (Chromecast) — funciona no navegador Chrome (desktop/Android).
// Dentro do WebView do app NÃO funciona (o WebView não tem o motor de cast do Google);
// lá o cast precisaria ser nativo. No iOS o cast é via AirPlay (não usa este SDK).

let loadPromise = null;

function initContext() {
    try {
        const context = window.cast.framework.CastContext.getInstance();
        context.setOptions({
            receiverApplicationId: window.chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
            autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
        });
        return true;
    } catch (e) {
        return false;
    }
}

// Carrega o SDK do Cast uma única vez. Resolve true se disponível (Chrome), false caso contrário.
export function loadCastSdk() {
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve) => {
        if (window.cast && window.cast.framework) { resolve(initContext()); return; }
        // o SDK chama este callback global quando termina de carregar
        window.__onGCastApiAvailable = (isAvailable) => {
            resolve(isAvailable ? initContext() : false);
        };
        const s = document.createElement('script');
        s.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
        s.async = true;
        s.onerror = () => resolve(false);
        document.head.appendChild(s);
    });
    return loadPromise;
}

// Pré-carrega o SDK (deixa o botão pronto). Ignora iOS (que usa AirPlay).
export function preloadCast() {
    if (typeof navigator !== 'undefined' && /iPhone|iPad|iPod/.test(navigator.userAgent)) return;
    loadCastSdk().catch(() => {});
}

// Abre o seletor de TV e manda o HLS pra Chromecast. Retorna true se conseguiu.
export async function castToTv(url, meta = {}) {
    const ok = await loadCastSdk();
    if (!ok || !url) return false;

    const context = window.cast.framework.CastContext.getInstance();
    try {
        await context.requestSession(); // abre o diálogo nativo de dispositivos do Chrome
    } catch (e) {
        return false; // usuário cancelou ou nenhum dispositivo encontrado
    }

    const session = context.getCurrentSession();
    if (!session) return false;

    const mediaInfo = new window.chrome.cast.media.MediaInfo(url, 'application/x-mpegURL');
    mediaInfo.metadata = new window.chrome.cast.media.GenericMediaMetadata();
    if (meta.title) mediaInfo.metadata.title = meta.title;
    if (meta.poster) mediaInfo.metadata.images = [new window.chrome.cast.Image(meta.poster)];

    const request = new window.chrome.cast.media.LoadRequest(mediaInfo);
    try {
        await session.loadMedia(request);
        return true;
    } catch (e) {
        return false;
    }
}
